<div class="title">Update Status</div>

<div class="message">
  <span>Manually update an offer status for tracking.</span> <br>
  <span>Note: Once an offer is updated from "New" status, it can no longer be edited.</span>
</div>

<div class="radios">
  <mat-radio-group class="radio-group" [formControl]="statusControl">
    <mat-radio-button color="primary" class="arb-radio" [value]="accepted">Accepted</mat-radio-button>
    <mat-radio-button color="primary" class="arb-radio" [value]="rejected">Rejected</mat-radio-button>
  </mat-radio-group>
</div>

<div class="actions">
  <button mat-dialog-close mat-flat-button class="cancel">Cancel</button>
  <button (click)="onSave()" mat-flat-button color="primary" class="save">Save</button>
</div>